@if (edit) {
    <clp-toolbar [title]="('category.update.title' | translate)"></clp-toolbar>
} 
@else {
    <clp-toolbar [title]="('category.create.title' | translate)"></clp-toolbar>    
}

<div class="mt-10 flex justify-center">
    <div class="w-full max-w-lg">
        <form class="space-y-4" (ngSubmit)="changeCategory(categoryForm.value)" [formGroup] = "categoryForm">
            <input type="hidden" formControlName="id">

            <div>
                <label class="clp-label">{{'category.create.name' | translate}}</label>
                <input class="clp-input" formControlName="name">
                @if (categoryForm.controls['name'].invalid && categoryForm.controls['name'].dirty) {
                    <em class="clp-help">{{'category.create.invalidName' | translate}}</em>
                }
            </div>

            <div class="flex justify-end">
                <button class="clp-btn clp-btn-warning" type="submit">{{'general.save' | translate}}</button>
            </div>
        </form>
    </div>
</div>
